import React, { Component } from "react";
import FormStyle from './FormStyle'

class ContactTwo extends Component{
    render(){
        return(
            <div className="contact-form--1">
                <div className="container">
                    <div className="row row--35 align-items-start">
                        <div className="col-lg-6 order-2 order-lg-1">
                            <div className="section-title text-left mb--50">
                                <span className="subtitle">What's Poppin'?</span>
                                <h2 className="title">Contact Us.</h2>
                                <div className="im_address">
                                    <span>Call Me:</span>
                                    <a className="link im-hover" href="tel:541-933-5322">541.933.5322</a>
                                </div>
                                <div className="im_address mt--5">
                                    <span>Email Me:</span>
                                    <a className="link im-hover" href="mailto:auz@digitm.com">auz@digitm.com</a>
                                </div>
                            </div>
                            <FormStyle />
                        </div>
                        <div className="col-lg-6 order-1 order-lg-2">
                            <div className="thumbnail mb_md--30 mb_sm--30">
                                <img src="/assets/images/about/about-12.jpg" alt="trydo"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ContactTwo;